import { render, staticRenderFns } from "./QuotationConfirmation.vue?vue&type=template&id=6c38a044&"
import script from "./QuotationConfirmation.vue?vue&type=script&lang=js&"
export * from "./QuotationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./QuotationConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports